var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c(
        "ItpBox",
        { staticClass: "items-spacing w-100", attrs: { alignItems: "center" } },
        [
          _c(
            "ItpBox",
            { attrs: { direction: "column" } },
            [
              _vm.resourceTitle
                ? _c("ItpText", {
                    staticClass: "mb-0",
                    attrs: { muted: "", text: _vm.resourceTitle }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("ItpText", {
                staticClass: "mb-0",
                attrs: { tag: "h5", text: _vm.resourceKey }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-button-group",
            { staticClass: "ml-auto" },
            [
              !_vm.item.isNew
                ? _c("ItpButton", {
                    staticClass: "ml-auto",
                    attrs: {
                      icon: "fa-sync-alt",
                      tooltip: _vm._f("gettext")("Reload"),
                      spinning: _vm.actions.reload.isRunning,
                      variant: "light"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.evh_1040167445267876_clickPreventStop(
                          $event,
                          {}
                        )
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.item.isNew
                ? _c(
                    "b-dropdown",
                    {
                      staticClass: "border",
                      attrs: { right: "", variant: "light" }
                    },
                    [
                      _c("ItpIcon", {
                        staticClass: "mx-1",
                        attrs: { slot: "button-content", fa: "bars" },
                        slot: "button-content"
                      }),
                      _vm._v(" "),
                      !_vm.item.isNew && _vm.item.meta && _vm.item.meta.can_lock
                        ? _c("ItpButton", {
                            attrs: {
                              "dropdown-item": "",
                              text: _vm._f("pgettext")("Lock", "BtnLockText"),
                              tooltip: _vm._f("pgettext")(
                                "Lock",
                                "BtnLockTooltip"
                              ),
                              variant: "default"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.evh_3601807637515735_clickPreventStop(
                                  $event,
                                  {}
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.item.isNew &&
                      _vm.item.meta &&
                      _vm.item.meta.can_unlock
                        ? _c("ItpButton", {
                            attrs: {
                              "dropdown-item": "",
                              text: _vm._f("pgettext")("Unlock", "BtnLockText"),
                              tooltip: _vm._f("pgettext")(
                                "Unlock",
                                "BtnLockTooltip"
                              ),
                              variant: "default"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.evh_4139696446929656_clickPreventStop(
                                  $event,
                                  {}
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.item.isNew &&
                      _vm.item.meta &&
                      _vm.item.meta.can_invalidate
                        ? _c("ItpButton", {
                            attrs: {
                              "dropdown-item": "",
                              text: _vm._f("pgettext")(
                                "Invalidate",
                                "BtnLockText"
                              ),
                              tooltip: _vm._f("pgettext")(
                                "Invalidate",
                                "BtnLockTooltip"
                              ),
                              variant: "default"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.evh_4700643919467772_clickPreventStop(
                                  $event,
                                  {}
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.item.isNew &&
                      _vm.item.meta &&
                      _vm.item.meta.can_revoke_invalidation
                        ? _c("ItpButton", {
                            attrs: {
                              "dropdown-item": "",
                              text: _vm._f("pgettext")(
                                "Revoke invalidated",
                                "BtnLockText"
                              ),
                              tooltip: _vm._f("pgettext")(
                                "Revoke invalidated",
                                "BtnLockTooltip"
                              ),
                              variant: "default"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.evh_295664594794476_clickPreventStop(
                                  $event,
                                  {}
                                )
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.item.isNew && !_vm.item.isReadOnly
                        ? _c("BtnDeleteResource", {
                            attrs: {
                              "no-icon": "",
                              "dropdown-item": "",
                              resource: _vm.item,
                              tooltip: _vm._f("pgettext")(
                                "Delete",
                                "Resource|Command"
                              )
                            },
                            on: {
                              success: function($event) {
                                return _vm.evh_8474446275270171_success(
                                  $event,
                                  {}
                                )
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }